/**简单的日志过滤
 * Created by zangxiangming1
 * Date: 2022/9/9
 * Time: 09:27
 * Description:
 */

export const setLog = () => {
    const before = '❤️ tag--';
    const additional = {
        division: before + '->',
        name (t){
            this.division = before + t;
            return this;
        },
        add (...txt) {
            console.group(additional.division);
            this._write(txt);
            setTimeout(_=> this._end(), 10)
            return this;
        },
        _write (data) {
            Object.keys(data).map(value => console.info(data[value]));
        },
        _end() {
            console.groupEnd()
        }
    }
    return additional;
}
